// import Http from './http'; // não precisa de .js

import axios from "axios";
import api from "../utils/api";

const config = {
  auth: {
    username: process.env.VUE_APP_ZOOP_PUBLISHABLE_KEY,
    password: "",
  },
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers":
      "Origin, X-Requested-With, Content-Type, Accept",
  },
};

const zoop_baseurl =
  process.env.VUE_APP_ZOOP_BASE_URL + process.env.VUE_APP_ZOOP_MARKETPLACE;

const token = localStorage.getItem("token");
// console.log('card token: ', token)
if (token) axios.defaults.headers.get["Authorization"] = "Bearer " + token;

export const addBuyer = (buyer) =>
  api.post("/addBuyer", buyer, {
    headers: { Authorization: "Bearer " + token },
  });

export const addCardToken = (card) =>
  api.post("/addCardToken", card, {
    headers: { Authorization: "Bearer " + token },
  });

export const addCardUser = (cardUser) =>
  api.post("/addCardUser", cardUser, {
    headers: { Authorization: "Bearer " + token },
  });
// export const updateUser = (uid, user) => client.patch('/updateUser/' + uid, user);

export const getCardDetail = (card_id) => {
  return api.get(zoop_baseurl + "/cards/" + card_id, config);
};

/*
export const getCardDetail = (card_id) => {
  return axios.get('/getCard/' + card_id, {headers: {'Authorization': 'Bearer ' + token}});
};
*/

export const addTransaction = (transaction) =>
  api.post("/addTransaction", transaction, {
    headers: { Authorization: "Bearer " + token },
  });

/*
export const getCards = (uid) => {
  return axios.get('/getCards/' + uid, {headers: {'Authorization': 'Bearer ' + token}});
};
*/
